import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import UpdateBanner from './UpdateBanner';
import AnimatedBackground from './AnimatedBackground';

export default function Layout() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="relative min-h-screen bg-background text-foreground">
      <AnimatedBackground />
      <UpdateBanner />
      <Navbar />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
